module.exports = __webpack_public_path__ + "img/title-img2.9f416ce7.png";